import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SchoolService from "services/SchoolService";

// Academic Year

export const getAcademicYear = createAsyncThunk(
  "school/getAcademicYear",
  async (params, { rejectWithValue }) => {
    try {
      const response = await SchoolService.getAcademicYear(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getRecentAcademicYear = createAsyncThunk(
  "school/getRecentAcademicYear",
  async (params, { rejectWithValue }) => {
    try {
      const response = await SchoolService.getRecentAcademicYear(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const downloadAcademiyearExcel = createAsyncThunk(
  "user/downloadAcademiyearExcel",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await SchoolService.downalodExcel(data, params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getSingleAcademicYear = createAsyncThunk(
  "school/getSingleAcademicYear",
  async (params, { rejectWithValue }) => {
    try {
      const response = await SchoolService.getSingleAcademicYear(params);
      console.log(response);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const updateAcademicYearStatus = createAsyncThunk(
  "school/updateAcademicYearStatus",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await SchoolService.updateAcademicYearStatus(
        data,
        params
      );
      console.log(response);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update status"
      );
    }
  }
);
export const updateBulkAcademicYearStatus = createAsyncThunk(
  "school/updateBulkAcademicYearStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SchoolService.updateBulkAcademicYearStatus({
        data,
      });
      return response;
    } catch (err) {
      console.log(err);

      return rejectWithValue(
        err.response?.data?.message || "Failed to update status"
      );
    }
  }
);

export const addAcademicYear = createAsyncThunk(
  "school/addAcademicYear",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SchoolService.addAcademicYear(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add academic year"
      );
    }
  }
);
export const editAcademicYear = createAsyncThunk(
  "school/editAcademicYear",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await SchoolService.editAcademicYear(id, data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to edit academic year"
      );
    }
  }
);

// School

export const getSchool = createAsyncThunk(
  "school/getSchool",
  async (params, { rejectWithValue }) => {
    try {
      const response = await SchoolService.getSchool(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const downloadSchoolExcel = createAsyncThunk(
  "user/downloadSchoolExcel",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await SchoolService.downalodSchoolExcel(data, params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getSingleSchool = createAsyncThunk(
  "school/getSingleSchool",
  async (id, { rejectWithValue }) => {
    try {
      const response = await SchoolService.getSingleSchool(id);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch school data"
      );
    }
  }
);
export const updateSchoolStatus = createAsyncThunk(
  "school/updateSchoolStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SchoolService.updateSchoolStatus(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update status"
      );
    }
  }
);
export const addSchoolGroup = createAsyncThunk(
  "school/addSchoolGroup",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SchoolService.addSchoolGroup(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add School Group"
      );
    }
  }
);
export const getSchoolGroup = createAsyncThunk(
  "school/getSchoolGroup",
  async (params, { rejectWithValue }) => {
    try {
      const response = await SchoolService.getSchoolGroup(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch School Group "
      );
    }
  }
);
export const getPackageList = createAsyncThunk(
  "school/getPackageList",
  async (params, { rejectWithValue }) => {
    try {
      const response = await SchoolService.getPackageList(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const studentInviteData = createAsyncThunk(
  "school/studentInviteData",
  async (params, { rejectWithValue }) => {
    try {
      const response = await SchoolService.studentInviteData(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch student Invite Data"
      );
    }
  }
);
export const addSchool = createAsyncThunk(
  "school/addSchool",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await SchoolService.addSchool(data, params);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add School"
      );
    }
  }
);
export const editSchool = createAsyncThunk(
  "school/editSchool",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await SchoolService.EditSchool(data, params);
      console.log(response);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to edit academic year"
      );
    }
  }
);
export const updateBulkSchoolStatus = createAsyncThunk(
  "school/updateBulkSchoolStatus",
  async ({ data, status }, { rejectWithValue }) => {
    try {
      const response = await SchoolService.updateBulkSchoolStatus(data, status);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update status"
      );
    }
  }
);
export const updatePackageList = createAsyncThunk(
  "school/updatePackageList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SchoolService.updatePackageList(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update List"
      );
    }
  }
);
export const updateBasePriceList = createAsyncThunk(
  "school/updateBasePriceList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SchoolService.updateBasePriceList(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update List"
      );
    }
  }
);
export const addPromoCode = createAsyncThunk(
  "school/addPromoCode",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SchoolService.addPromoCode(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add School"
      );
    }
  }
);
export const editPromoCode = createAsyncThunk(
  "school/editPromoCode",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SchoolService.editPromoCode(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add School"
      );
    }
  }
);
export const deleteLinkStudent = createAsyncThunk(
  "school/deleteLinkStudent",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SchoolService.deleteLinkStudent(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete School"
      );
    }
  }
);
export const getPromoCodeList = createAsyncThunk(
  "school/getPromoCodeList",
  async (params, { rejectWithValue }) => {
    try {
      const response = await SchoolService.getPromoCodeList(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch student Invite Data"
      );
    }
  }
);
export const getSinglePromo = createAsyncThunk(
  "school/getSinglePromo",
  async (params, { rejectWithValue }) => {
    try {
      const response = await SchoolService.getSinglePromo(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch getSinglePromo"
      );
    }
  }
);
const schoolSlice = createSlice({
  name: "school",
  initialState: {
    academicYears: [],
    recentAcademicYears: [],
    packageList: {},
    schoolGroups: {},
    promoCodeList: {},
    singlePromo: {},
    inviteData: {},
    singleSchool: {},
    loading: false,
    schools: {},
    error: null,
    message: null,
  },
  reducers: {
    clearSchoolError: (state) => {
      state.error = null;
    },
    clearPackageList: (state) => {
      state.packageList = {};
      state.error = null;
    },
    clearSchoolData: (state) => {
      state.packageList = {};
      state.inviteData = {};
      state.singleSchool = {};
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Academic Year

      .addCase(getAcademicYear.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAcademicYear.fulfilled, (state, action) => {
        state.loading = false;
        state.academicYears = action.payload;
      })
      .addCase(getAcademicYear.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getRecentAcademicYear.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRecentAcademicYear.fulfilled, (state, action) => {
        state.loading = false;
        state.recentAcademicYears = action.payload;
      })
      .addCase(getRecentAcademicYear.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // excel

      .addCase(downloadAcademiyearExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadAcademiyearExcel.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadAcademiyearExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // SINGLE

      .addCase(getSingleAcademicYear.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleAcademicYear.fulfilled, (state, action) => {
        state.loading = false;
        state.singleAcademicYear = action.payload;
      })
      .addCase(getSingleAcademicYear.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateAcademicYearStatus.fulfilled, (state, action) => {
        state.message = action.payload;
      })

      .addCase(updateAcademicYearStatus.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(addAcademicYear.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAcademicYear.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
      })

      .addCase(addAcademicYear.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editAcademicYear.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editAcademicYear.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
      })
      .addCase(editAcademicYear.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // School

      .addCase(getSchool.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSchool.fulfilled, (state, action) => {
        state.loading = false;
        state.schools = action.payload;
      })
      .addCase(getSchool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadSchoolExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadSchoolExcel.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadSchoolExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getSingleSchool.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.singleSchool = null;
      })
      .addCase(getSingleSchool.fulfilled, (state, action) => {
        state.loading = false;
        state.singleSchool = action.payload;
      })
      .addCase(getSingleSchool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateSchoolStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSchoolStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateSchoolStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addSchoolGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.addGroupSuccess = false;
      })
      .addCase(addSchoolGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.addGroupSuccess = true;
        // Optionally push new group to schools if needed
        // state.schools.push(action.payload);
      })
      .addCase(addSchoolGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.addGroupSuccess = false;
      })
      .addCase(addSchool.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(addSchool.fulfilled, (state, action) => {
        state.loading = false;
        state.schools = action.payload;
        state.successMessage = "School added successfully.";
      })
      .addCase(getSchoolGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSchoolGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.schoolGroups = action.payload.items;
      })
      .addCase(getSchoolGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addSchool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // EDIT SCHOOL
      .addCase(editSchool.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editSchool.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editSchool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // bulk status update

      .addCase(updateBulkSchoolStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBulkSchoolStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateBulkSchoolStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getPackageList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPackageList.fulfilled, (state, action) => {
        state.loading = false;
        state.packageList = action.payload;
      })
      .addCase(getPackageList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // updatePackageList

      .addCase(updatePackageList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePackageList.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updatePackageList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // studentInviteData

      .addCase(studentInviteData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(studentInviteData.fulfilled, (state, action) => {
        state.loading = false;
        state.inviteData = action.payload;
      })
      .addCase(studentInviteData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // updateBasePriceList

      .addCase(updateBasePriceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBasePriceList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateBasePriceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // addPromoCode

      .addCase(addPromoCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPromoCode.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addPromoCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // editPromoCode

      .addCase(editPromoCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editPromoCode.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editPromoCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // getPromoCodeList

      .addCase(getPromoCodeList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPromoCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.promoCodeList = action.payload;
      })
      .addCase(getPromoCodeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // deleteLinkStudent

      .addCase(deleteLinkStudent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLinkStudent.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteLinkStudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // getSinglePromo

      .addCase(getSinglePromo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSinglePromo.fulfilled, (state, action) => {
        state.loading = false;
        state.singlePromo = action.payload;
      })
      .addCase(getSinglePromo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { clearSchoolError, clearPackageList, clearSchoolData } =
  schoolSlice.actions;

export default schoolSlice.reducer;
